/* global webpack */

import angular from 'angular'

import envRaw from '../utils/env-raw'
import attachEmitters from '../utils/attach-emitters'

import { makeOR } from '../utils/bits'
import { toUrl, toSrc } from '../utils/security'
import { wrap, uniqueId } from 'lodash-es'

import Template from './gallery-branding.component.ejs'

angular
  .module('ggs.gallery-branding')
  .component('ggsGalleryBranding', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryBrandingComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<',
      ggsIsTinyLayout: '<'
    }
  })

const BASE_URL_PLH = ':base_url:'
const BRANDING_URL_TMPL = `${BASE_URL_PLH}/app/gallery`
import BRANDING_LOGO_SVG from '../../img/branding-logo.svg'

function GalleryBrandingComponent(
  qh,
  $log,
  $scope,
  DefineMethod,
  DefineHandler,
  GalleryBrandingStyleHandlers) {

  const sign = `galleryBranding[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = this
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)
  const styleHandlers = GalleryBrandingStyleHandlers()

  $ctrl.isTinyLayout = attachEmitters(
    $ctrl.ggsIsTinyLayout,
    $ctrl.ggsProperties.key2emitter.branding_footer_force_tiny,
    makeOR(
      $ctrl.ggsIsTinyLayout,
      $ctrl.ggsProperties.key2get.branding_footer_force_tiny))

  $ctrl.wrapM('attachToStyler',
    qh.makeCatch(
      wrap(styleHandlers, $ctrl.ggsStylerNew.reg),
      wrap(`${sign}#attachToStyler: error halted:`, $log.error)))

  $ctrl.wrapH('$onInit', $ctrl.attachToStyler)

  $ctrl.wrapH('$onDestroy',
    wrap(styleHandlers, $ctrl.ggsStylerNew.release))

  $ctrl.getBrandingUrl = () =>
    toUrl(BRANDING_URL_TMPL.replace(BASE_URL_PLH, webpack.apiServerHost))

  $ctrl.getBrandingLogo = () =>
    toSrc(BRANDING_LOGO_SVG)
}
